import { InFoPartNers } from '@/mocks/partners';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

interface IPartners {
  noHeader?: boolean;
}

const Partner = ({ noHeader }: IPartners) => {
  return (
    <div
      className={`container flex flex-col items-center gap-6 ${noHeader ? 'py-0' : 'py-8 md:py-16'} `}
    >
      {!noHeader && (
        <p className="uppercase text-[24px] md:text-[32px] font-bold">
          Đối tác của chúng tôi
        </p>
      )}
      <div className="grid grid-cols-2 md:grid-cols-7 w-full gap-4 md:gap-8">
        {InFoPartNers.map((item, index) => (
          <div
            key={index}
            className="flex justify-center items-center p-4 md:p-6"
          >
            <Link
              href={item.href}
              className="relative w-full h-[60px] md:h-[80px] lg:h-[100px] flex justify-center items-center"
            >
              <Image
                src={item.logo}
                alt={`Logo đối tác ${index + 1} của Trường Thọ Food`}
                fill
                style={{ objectFit: 'contain' }}
                className="opacity-80 hover:opacity-100 transition-opacity duration-300"
              />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partner;
